import { Component, Vue } from 'vue-facing-decorator';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Check, Checked, Delete, EditPen, CirclePlusFilled, Briefcase } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
        Check,
        EditPen,
        Delete,
        CirclePlusFilled,
        Briefcase
    },
    enums:
    {
        NavigationIndex
    }
})

export default class Customer extends Vue 
{
    private activeName: string = "1";   
    private customerModelList : CustomerModel[] = [];
    private tableData: object[] = [];
    private loading : boolean = true;
    private formValid : boolean = false;
    private hasPermission: boolean[] = [] as boolean[];
    private toDelete : CustomerModel | undefined;
    private newCustomerModel : CustomerModel = {} as CustomerModel;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private allowedPrefixChars : string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    private rules =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine E-Mail ein.",
                trigger: "blur"
            }
        ],
        tokenprefix:
        [
            {
                required: true,
                message: "Bitte geben Sie ein Kürzel für die Tickets ein.",
                trigger: "blur"
            }
        ]
    };

    public async mounted()
    {
        let isCustomer : boolean = await AuthService.isCustomer();

        if (isCustomer)
        {
            await this.loadList();

            if (this.customerModelList.length > 0)
            {
                this.$router.push(`/customer/${this.customerModelList[0].customerid}`);
            }
        }

        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['CUST_SELECT'] = AuthService.hasPermission("CUST_SELECT");
        this.hasPermission['CUST_INSERT'] = AuthService.hasPermission("CUST_INSERT");
        this.hasPermission['CUST_UPDATE'] = AuthService.hasPermission("CUST_UPDATE");
        this.hasPermission['CUST_DELETE'] = AuthService.hasPermission("CUST_DELETE");


        if (this.hasPermission['CUST_SELECT'])
        {
            await this.loadList();
        }

        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadList()
    {
        this.loading = true;
        this.customerModelList = await ApiService.getAllCustomers() as CustomerModel[];
        this.loading = false;
    }

    private async saveCustomer(customer : CustomerModel)
    {
        let ok : any = await ApiService.updateCustomer(customer);

        if (ok)
        {
            // show message on success
			ElMessage({message: "Änderungen wurden übernommen.", type: 'success'});
        }
        else
        {
            // or show error message
			ElMessage({message: "Änderungen konnten nicht gespeichert werden.",	type: 'error'});
        }
    }

    private async createCustomer()
    {
        // send new customer model via request to API and await
        let customer = await ApiService.createCustomer(this.newCustomerModel);

        // check if successful
        if (customer)
        {
			ElMessage({message: "Neuer Mandant wurde erfolgreich erstellt.",	type: 'success'});
            this.activeName = "1";
            this.newCustomerModel = {} as CustomerModel;
            this.formValid = false;
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage({message: "Beim Erstellen des neuen Mandanten ist ein Fehler aufgetreten.",	type: 'error'});
        }
    }

    private async deleteCustomer(customer : CustomerModel)
    {
        let ok = await ApiService.deleteCustomer(customer);

        if (ok)
        {
			ElMessage({message: "Mandant wurde erfolgreich gelöscht.",	type: 'success'});
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage({message: "Mandant konnte nicht gelöscht werden.",	type: 'error'});
        }
    }

    private validateForm() : boolean
    {
        if (!this.newCustomerModel.name || this.newCustomerModel.name.length <= 0 || !this.newCustomerModel.email || this.newCustomerModel.email.length <= 0) return false;

        if (!this.newCustomerModel.tokenprefix || this.newCustomerModel.tokenprefix.length < 2) return false;
        for (let c of this.newCustomerModel.tokenprefix)
        {
            if (this.allowedPrefixChars.indexOf(c) < 0) return false;
        }

        return true;
    }

    private onInput()
    {
        if (this.newCustomerModel.tokenprefix)
        {
            this.newCustomerModel.tokenprefix = this.newCustomerModel.tokenprefix.toUpperCase();
        }
        this.formValid = this.validateForm();
    }

    private onCustomerSaveClick(customer : CustomerModel)
    {
        this.saveCustomer(customer);
    }

    private onDeleteConfirm(action : string)
    {
        if (this.toDelete && action == 'confirm')
        {
            this.deleteCustomer(this.toDelete);
        }
    }

    private onCustomerDeleteClick(customer : CustomerModel)
    {
        this.toDelete = customer;

        ElMessageBox.confirm('Soll dieser Mandant wirklich gelöscht werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onCustomerEditClick(customer : CustomerModel)
    {
        this.$router.push(`/customer/${customer.customerid}`);
    }

    private onNewCustomerClick()
    {
        this.createCustomer();
    }
    
}
